"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMonthData = void 0;
var createUTCDate = function createUTCDate(year, month) {
  var day = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return new Date(Date.UTC(year, month, day));
};
var formatMonthLabel = (date, locale, currentYear) => {
  var month = date.toLocaleString(locale, {
    timeZone: 'UTC',
    month: 'long'
  });
  var year = date.getUTCFullYear();
  var suffix = year > currentYear ? " '".concat(String(year).slice(-2)) : '';
  return "".concat(month).concat(suffix);
};
var generateMonthData = exports.generateMonthData = function generateMonthData() {
  var maxMonths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-GB';
  var today = new Date();
  var currentUTCYear = today.getUTCFullYear();
  var currentUTCMonth = today.getUTCMonth();
  var basePrice = 80;
  return Array.from({
    length: maxMonths
  }, (_, i) => {
    var date = createUTCDate(currentUTCYear, currentUTCMonth + i);
    var label = formatMonthLabel(date, locale, currentUTCYear);
    var value = "".concat(date.getUTCFullYear(), "-").concat(String(date.getUTCMonth() + 1).padStart(2, '0'));
    var price = basePrice + i * 10;
    return {
      value,
      label,
      date,
      price
    };
  });
};